import React from 'react';
import * as ReactRouterDOM from 'react-router-dom';
import { AppProvider, useApp } from './context/AppContext';
import Layout from './components/Layout';
import DynamicPage from './components/DynamicPage';
import ProductDetailsPage from './components/ProductDetailsPage';
import ThankYouPage from './components/ThankYouPage';
import AdminLogin from './components/AdminLogin';
import FavoritesPage from './components/FavoritesPage';

// Używamy HashRouter (np. twojastrona.pl/test/#/admin)
// To rozwiązuje 99% problemów z routingiem na tanich hostingach i w podkatalogach.
const { HashRouter: Router, Routes, Route, Navigate } = ReactRouterDOM as any;

const AppRoutes = () => {
  const { pages } = useApp(); // useApp inside Router to verify context

  return (
    <Routes>
      <Route path="/admin" element={<AdminLogin />} />
      <Route path="/product/:productId" element={<ProductDetailsPage />} />
      <Route path="/ulubione" element={<FavoritesPage />} />
      <Route path="/dziekujemy" element={<ThankYouPage />} />
      {pages.map(page => (
        <Route 
          key={page.id} 
          path={page.slug} 
          element={<DynamicPage page={page} />} 
        />
      ))}
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
};

const App: React.FC = () => {
  return (
    <AppProvider>
      <Router>
        <Layout>
          <AppRoutes />
        </Layout>
      </Router>
    </AppProvider>
  );
};

export default App;